/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Bookmarked = ({ color = 'forest', height = 20, ...props }) => {
  return (
    <svg
      width={10}
      height={height}
      viewBox="0 0 10 20"
      sx={{ fill: color }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0v20l5-5.128L10 20V0H0z"
      />
    </svg>
  )
}

Bookmarked.propTypes = {
  color: string,
  height: number,
}

export default Bookmarked
